import { DefaultFilters } from './types';
import * as React from 'react';

type DefaultFiltersSetter = (newDefaultFilters: DefaultFilters) => void;
type DefaultFiltersContextValues = [DefaultFilters, DefaultFiltersSetter];

const SelectedDefaultFiltersContext =
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  React.createContext<DefaultFiltersContextValues>(null);

/**
 * @description A hook for reading and setting the default filters available
 * to the OE.
 */
function useDefaultFilters() {
  const context = React.useContext(SelectedDefaultFiltersContext);

  if (!context) {
    throw new Error(
      'useDefaultFilters must be used within a DefaultFiltersProvider',
    );
  }

  return context;
}

function DefaultFiltersProvider(props: any) {
  const [selectedDefaultFilters, setSelectedDefaultFilters] =
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    React.useState<DefaultFilters>(null);

  const value = React.useMemo(
    () => [selectedDefaultFilters, setSelectedDefaultFilters],
    [selectedDefaultFilters],
  );

  return <SelectedDefaultFiltersContext.Provider value={value} {...props} />;
}

export { DefaultFiltersProvider, useDefaultFilters };
